import _ from 'lodash'
import React from 'react'

import { IBaseProps } from 'browser/components/atomic-elements/atoms/base-props'
import { LoadingSpinner } from 'browser/components/atomic-elements/atoms/loading-spinner/loading-spinner'
import 'browser/components/atomic-elements/organisms/feed/_event.scss'
import 'browser/components/atomic-elements/organisms/feed/_feed.scss'

import apis from 'browser/app/models/apis'
import { Entity } from 'shared-libs/models/entity'
import { AiBlockActivityView } from './ai-block-activity-view'

/**
 * @uiComponent
 */
interface IAiBlockUsageActivityProps extends IBaseProps {
  entity?: Entity
  entityId?: string
}

interface IAiBlockUsageActivityState {
  isLoading: boolean
}

/**
 * Display the AI block usage activity for a given entity.
 */
export class AiBlockUsageActivity extends React.Component<
  IAiBlockUsageActivityProps,
  IAiBlockUsageActivityState
> {
  public static defaultProps: Partial<IAiBlockUsageActivityProps> = {}

  private usageEntity: Entity | null = null
  private store: any

  constructor(props: IAiBlockUsageActivityProps) {
    super(props)
    this.state = {
      isLoading: true,
    }
    this.store = apis.getStore()
  }

  public componentDidMount() {
    void this.fetchUsageEntity()
  }

  public componentWillUnmount() {}

  public shouldComponentUpdate(
    nextProps: Readonly<IAiBlockUsageActivityProps>,
    nextState: Readonly<IAiBlockUsageActivityState>,
    nextContext: any
  ): boolean {
    return !_.isEqual(this.props, nextProps) || !_.isEqual(this.state, nextState)
  }

  public render() {
    return this.state.isLoading ? this.renderLoading() : this.renderExecutions()
  }

  private fetchUsageEntity = async () => {
    const entity = this.props.entity
    if (!entity) return

    const usageEntityId = entity.get('core_blocks_execution.usageLog.entityId')
    if (!usageEntityId) {
      this.setState({ isLoading: false })
      return
    }

    try {
      const usageEntity = await this.store.getEntity(usageEntityId)
      this.usageEntity = usageEntity
    } finally {
      this.setState({ isLoading: false })
    }
  }

  private renderLoading = () => {
    return <LoadingSpinner />
  }

  private renderExecutions = () => {
    return <AiBlockActivityView entity={this.props.entity} usageEntity={this.usageEntity} />
  }
}
